import { clientOnlyLazy } from 'components/ClientOnlySuspense/clientOnlyLazy';
import LoadingModal from 'modals/LoadingModal';

export const InformationRequiredModalContainerLoadable = clientOnlyLazy({
  loader: () =>
    import(
      /* webpackChunkName: "InformationRequiredModalContainer" */
      './InformationRequiredModalContainer.dynamic'
    ),
  loading: LoadingModal,
});
